export const TASK_STATUS = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  ARCHIVED: 'ARCHIVED',
} as const;

export const TASK_STATUS_VALUES = Object.values(TASK_STATUS);

export type TaskStatus = (typeof TASK_STATUS)[keyof typeof TASK_STATUS];
